import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SafeHtmlPipe } from "./safe-html.pipe";

@NgModule({
  declarations: [
    SafeHtmlPipe,
  ],
  exports: [
    SafeHtmlPipe,
  ],
  imports: [
    CommonModule,
  ],
})
export class SafeHtmlModule { }
